"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResolutionRegex = void 0;
/**
 * please change accordly to above
 */
exports.ResolutionRegex = /^[0-9]{2,5}x[0-9]{2,5}$/g;
